var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error_message_container"},[_c('span',{staticClass:"error_text"},[_vm._v("\n    "+_vm._s(_vm.$t("k_566711a"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }